<template>
  <div class="payment">
    <div class="payment-title padding">支付</div>
    <div class="payment-type-one">
      <div class="payment-type-one-meal padding">
        <span class="f13 flex-shrink">使用套餐</span>
        <el-checkbox v-model="checkedmeal" @change="mealChange">
          使用套餐进行抵扣（当前套餐剩余份数 <span class="color-red">{{remainValue}}</span> 份）
        </el-checkbox>
        <p class="right-text payment-type-text">
          扣减：<span class="color-red">{{num}}份</span>
        </p>
      </div>
      <div :class="['payment-type-one-balance','padding', isoverdraft?'borderBot':'']">
        <span class="f13 flex-shrink">使用余额</span>
        <el-checkbox v-model="checkedbalance" @change="balanceChange">
          使用账户余额抵扣（当前帐户余额
          <span class="color-red">¥ {{balance}}</span>）如果余额不足，请选择其他支付方式进行付费。
        </el-checkbox>
        <p class="right-text payment-type-text">
          抵扣：<span class="color-red">¥ {{money}}</span>
        </p>
      </div>
      <div class="payment-type-one-balance padding" v-if="isoverdraft">
        <span class="f13 flex-shrink">使用透支</span>
        <el-checkbox v-model="checkedoverdraft" @change="overdraftChange">
          使用透支进行支付（当前可透支额度为 
          <span class="color-red">{{creditCurVaule}}</span>份）
        </el-checkbox>
        <p class="right-text payment-type-text">
          扣减：<span class="color-red">{{num}}份</span>
        </p>
      </div>
    </div>
    <div class="payment-type-other">
      <div class="payment-title other-title padding">
        <span>其他支付</span>
        <p class="right-text">
          支付：<span class="color-red">¥{{money}}</span>
        </p>
      </div>
      <div class="other-list">
        <el-radio-group
          v-model="otherType"
          @change="otherChange"
          class="other-list-content padding"
        >
          <div :class="['other-list-item',otherType==1?'other-list-item-active':'']">
            <el-radio label="1">
              <span class="other-item-text">支付宝</span>
            </el-radio>
            <img src="../../../assets/images/payment/alipay_icon.png" />
          </div>
          <div :class="['other-list-item',otherType==2?'other-list-item-active':'']">
            <el-radio label="2">
              <span class="other-item-text">微信支付</span>
            </el-radio>
            <img src="../../../assets/images/payment/weichatpay_icon.png" />
          </div>
        </el-radio-group>
      </div>
    </div>
     <div class="returnPay" v-html="returnPay"></div>
    <div class="payment-submit">
      <div>
        <p>
          {{payText}}：
          <span class="color-red" v-if='checkedmeal || checkedoverdraft'>{{num}}份</span>
          <span class="color-red" v-else>¥{{money}}</span>
        </p>
         <el-button :style="{'background':isSubmiting?'rgb(228, 226, 226)':'#db4437'}" :disabled="isSubmiting" @click="goPay">支付</el-button>
      </div>
    </div>

    <Dialog
        :visible="balanceOrmeal"
        :dialogTitle="'消息提示'"
        :width="'400px'"
        @closeDialog="closeDialog('balanceOrmeal')"
        class="mealBox"
      >
        <div class="balanceCon" slot="dialog">
          <div class="mealTop">确定支付此项费用？</div>
          <div class="mealBottom">
            <span @click="cancelFn">取消</span>
            <span @click="trueBalancePay">确定</span>
          </div>
        </div>
    </Dialog>
    <Dialog
        :visible="Payother"
        :dialogTitle="'消息提示'"
        :width="'400px'"
        @closeDialog="closeDialog('Payother')"
        class="mealBox"
      >
        <div class="balanceCon" slot="dialog">
          <div class="mealTop">是否已完成支付？</div>
          <div class="mealBottom">
            <span @click="cancelFn">取消</span>
            <span @click="finshedFn">确定</span>
          </div>
        </div>
    </Dialog>
     <Dialog
        :visible="wechatImg"
        :dialogTitle="'支付订单'"
        :width="'500px'"
        @closeDialog="closeDialog('wechatImg')"
        class="payImgDialogBox"
      >
      <div class="payImgDialog" slot="dialog">
        <div class="textAlign">
          <p>
            应付金额：
            <span>￥{{money}}元</span>
          </p>
          <p>打开微信扫一扫二维码支付</p>
        </div>
        <div class="payImgCon">
          <img :src="wechatresultImg">
          <img src="../../../assets/images/sign/weichatpay_img.png">
        </div>
        <div class="succfulBox textAlign">
          <span @click="finshedFn">若微信支付已完成，请点击</span>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script >
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
export default {
  data() {
    return {
      checkedmeal: true,
      checkedbalance: false,
      checkedoverdraft:false, //透支
      otherType: "",
      orderAmount: "",
      money:0,
      num: 0,
      returnList: "",
      balance: "",
      totalValue: 0,
      remainValue: 0,
      creditValue:0,//透支阈值
      creditUsedValue:0,//透支已使用量
      creditCurVaule:0,
      queryParams: {},
      Payother: false,
      balanceOrmeal: false,
      isSubmiting:true,
      wechatImg:false,
      payNo:"",
      wechatresultImg:"",
      returnPay:"",
      istrueBalancePay:false,
      isoverdraft:false,
      payText:"扣减",
      isCredit:0
    };
  },
  components:{Dialog},
  methods: {
    //选择套餐
    mealChange() {
      this.checkedmeal = true;
      this.payText="扣减";
      this.checkedoverdraft = false;
      this.setIsSubmit(this.remainValue,this.num);
      this.checkedbalance = false;
      this.otherType = "";
    },
    //选择余额
    balanceChange() {
      this.payText="抵扣";
      this.checkedbalance = true;
      this.checkedoverdraft = false;
      this.setIsSubmit(this.balance,this.money);
      this.checkedmeal = false;
      this.otherType = "";
    },
    //选择透支
    overdraftChange(){
      this.payText="扣减";
      this.checkedoverdraft = true;
      this.checkedmeal = false;
      this.checkedbalance = false;
      this.otherType = "";
      if(this.isCredit==1){
        this.isSubmiting=false;
      }
    },
    setIsSubmit(data1,data2){
      if(data1>=data2){
        this.isSubmiting=false;
      }else{
        this.isSubmiting=true;
      }
    },
    //选择支付宝或者微信支付
    otherChange() {
      this.payText="支付";
      if (this.otherType != "") {
        this.checkedbalance = false;
        this.checkedmeal = false;
        this.isSubmiting=false;
        this.checkedoverdraft = false;
      }
    },
    closeDialog(flag) {
      this[flag] = false;
      this.isSubmiting=false;
      if(flag=='wechatImg'){
        this.getPayStatus();
      }
    },
    //验证支付状态
    getPayStatus(){
      var statusStr = {
        payNo: this.payNo
      };
      BaseApi.createRpcToken("/pay/getPayStatus", statusStr, "post").then(
      data => {
        if (data.datas.flag == 1) {
          //发起签约
          if(this.$route.query.flag == 'startSign'){
            this.$router.push({ path: `/personal/sign/complete`,query:{
                id:this.queryParams.id,
                flag:'startSign',
                isSuccess:true,
                type:this.$route.query.type
              }
            });
          }else{
            //去签署
            this.goSingRouter();
          }
        } 
      },() => {})
    },
    cancelFn() {
      this.Payother = false;
      this.balanceOrmeal = false;
      this.isSubmiting=false;
    },
    getContractInfo() {
      return BaseApi.createRpcToken(
        "/contract/info",
        { id: this.queryParams.id },
        "post"
      );
    },
    //判断余额支付是否能支付
    async judgeBalance() {
      try {
        let orderAmount = await this.getOrderAmount();
        this.orderAmount = orderAmount;
        this.money = orderAmount.datas.amount - 0;
        this.num = orderAmount.datas.package.amount - 0;
        this.returnList = await this.getBanlance();
        this.balance = this.returnList.datas.balance;
        if (this.returnList.datas.hasOwnProperty("contractNum") == true) {
          this.totalValue = this.returnList.datas.contractNum.totalValue;
          this.remainValue = this.returnList.datas.contractNum.remainValue;
          this.creditValue = this.returnList.datas.contractNum.creditValue;
          this.isCredit= this.returnList.datas.contractNum.isCredit;
          this.creditUsedValue=this.returnList.datas.contractNum.creditUsedValue;
          this.creditCurVaule=this.creditUsedValue==undefined?this.creditValue - 0:this.creditValue-this.creditUsedValue
          if (this.remainValue >= this.num) {
            this.mealChange();
            return Promise.resolve(false);
          }
        }
        if (this.balance >= this.money) {
          this.balanceChange();
        } else {
          this.mealChange();
        }
        //不使用透支
        if(this.balance >= this.money || this.remainValue >= this.num){
          this.isoverdraft=false;
        }else {
          //判断是否开启透支权限:0-没有,1-有
          if( this.isCredit==1 && this.creditCurVaule){
            this.isoverdraft=true;
            //使用透支
            this.overdraftChange();
          } else{
            this.isoverdraft=false;
          }
        }
     
      } catch (e) {}
    },
    // 获取支付详情
    getPayNo(querStr) {
      return BaseApi.createRpcToken("/pay/getPayNo", querStr, "post");
    },
    //获取余额
    getBanlance() {
      return BaseApi.createRpcToken("/user/getBalance", "", "post");
    },
    // 获取合同需要的价钱
    getOrderAmount() {
      return BaseApi.createRpcToken("/pay/getOrderAmount", {
        businessType: 2,
        bussinessId: this.queryParams.id
      });
    },
    //微信、支付宝完成支付获取支付状态
    finshedFn() {
      var statusStr = {
        payNo: this.payNo
      };
      BaseApi.createRpcToken("/pay/getPayStatus", statusStr, "post").then(
        data => {
          if (data.datas.flag == 1) {
            //发起签约
            if(this.$route.query.flag == 'startSign'){
              this.$router.push({ path: `/personal/sign/complete`,query:{
                  id:this.queryParams.id,
                  flag:'startSign',
                  isSuccess:true,
                   type:this.$route.query.type
                }
              });
            }else{
              //去签署
              this.goSingRouter();
            }
          } else {
            this.$message.error("请确认已经支付");
          }
        },() => {}
      );
    },
    //跳转签署页面
    goSingRouter(){
      let url= `/personal/sign/index/signature`;
      if(this.queryParams.type==1){
         url= `/personal/sign/index/signature`;
      }else if(this.queryParams.type==2){
        url= `/personal/sign/signLoanIndex`;
      }else{
          url= `/personal/sign/signMediate`;
      }
      this.$router.push({ path: url, query:{
          isHandwriting:this.queryParams.isHandwriting,
          id:this.queryParams.id,
          taskId:this.queryParams.taskId,
          isCanReject:this.queryParams.isCanReject
        }
      });
    },
    //点击支付
    async goPay(){
      this.isSubmiting= true;
      //余额或者套餐支付
      if(this.checkedmeal || this.checkedbalance || this.checkedoverdraft){
        this.balanceOrmeal=true;
        this.Payother=false;
        this.wechatImg=false;
      }else if(this.otherType==1){
        //支付宝
        await this.aliPay();
      }else if(this.otherType==2){
        //微信
        await this.wechatPay();
      }
    },
    //余额支付
    async trueBalancePay() {
      if(!this.istrueBalancePay){
        this.istrueBalancePay = true;
        var querStr = {
          businessType: "2",
          payType: 1,
          sourceFrom: "1",
          totalPrice: this.money,
          bussinessId: this.queryParams.id
        };
        if(this.checkedbalance){//余额 
          querStr.payType=1;
        }else if(this.checkedmeal){//套餐
          querStr.payType=4;
          querStr.totalPrice=this.num;
        }else if(this.creditValue && this.isCredit==1){//透支
          querStr.payType=7;
          querStr.totalPrice=this.num;
        }
        let payInfo = await this.getPayNo(querStr);
        if (payInfo.datas.payNo) {
          //发起签约
          if(this.$route.query.flag == 'startSign'){
            this.$router.push({ path: `/personal/sign/complete`, query:{
                id:this.queryParams.id,
                flag:'startSign',
                 type:this.$route.query.type
              }
            });
          }else{
            this.goSingRouter();
          }
        }else{
          this.istrueBalancePay = false;
        }
      }
    },
    //微信支付方式
    async wechatPay(){
      var querStr = {
        businessType: "2",
        payType: '3',
        sourceFrom: "1",
        totalPrice: this.money,
        bussinessId: this.queryParams.id
      };
      let payInfo = await this.getPayNo(querStr);
      this.payNo=payInfo.datas.payNo;
      if (payInfo.datas.payType == "3") {
        var wechatStr = {
          payNo: payInfo.datas.payNo,
          payOrder: "2",
          body: ""
        };
        BaseApi.createRpcToken("/pay/wechat", wechatStr, "post").then(
          payData => {
            this.wechatImg = true;
            this.wechatresultImg = "data:image/png;base64," + payData.datas.image;
          },
          () => {
            this.isSubmiting = false;
          }
        );
      }
      this.balanceOrmeal=false;
      this.Payother=false
    },
    //支付宝方式
    async aliPay(){
      var querStr = {
        businessType: "2",
        payType: '2',
        sourceFrom: "1",
        totalPrice: this.money,
        bussinessId: this.queryParams.id
      };
      let payInfo = await this.getPayNo(querStr);
      this.payNo=payInfo.datas.payNo;
      var aliPayStr = {
        payNo: this.payNo,
        payOrder: "2",
        body: "",
        returnUrl:
        this.$GlobalConfig.currentUrl + "/verification/paySuccess"
      };
      BaseApi.createRpcToken(
        "/pay/aliPay",
        aliPayStr,
        "post",
        "",
        "",
        "",
        "",
        true
      ).then(
        aliPayData => {
          this.Payother = true;
          this.returnPay = aliPayData;
          setTimeout(function() {
            $("#alipaysubmit").attr("target", "_blank");
            document.forms["alipaysubmit"].submit();
          }, 500);
        },
        aliPayData => {}
      );
      this.balanceOrmeal=false;
      this.wechatImg = false;
    }
  },
  async created() {
    let that = this;
    this.queryParams = this.$route.query;
    this.getContractInfo().then(
      async function(data) {
        if (data.datas.info.payStatus == 0) {
          //未支付
          await that.judgeBalance();
        } else {
          if(that.$route.query.flag == 'startSign'){
            that.$router.push({path: `/personal/sign/complete`, query:{
                id:that.queryParams.id,
                flag:'startSign',
                type:this.$route.query.type
              }
            });
          }else{
            that.goSingRouter();
          }
        }
      },
      () => {
        that.isSubmiting = false;
      }
    );
  }
};
</script>
<style lang="scss" scoped>
.payment {
  width: 100%;
  height: 100%;
  background: #eaedf1;
  .payment-title {
    width: 100%;
    height: 48px;
    background: #fff;
    border-bottom: 1px dotted #eaedf1;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 48px;
  }
  .padding {
    box-sizing: border-box;
    padding: 0px 24px;
    color: rgba(30, 30, 30, 1);
  }
  .f13 {
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(80, 80, 80, 1);
  }
  .flex-shrink{
    flex-shrink: 0;
  }
  .color-red {
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #db4437;
  }
  .right-text {
    color: #787878;
  }
  .payment-type-one {
    width: 100%;
    background: #fff;
    margin-bottom: 9px;
    .borderBot{
      border-bottom: 1px solid #eaedf1;
    }
    .payment-type-one-meal {
      border-bottom: 1px solid #eaedf1;
      /deep/.el-checkbox {
        width: 60%;
      }
    }
    .payment-type-one-meal,
    .payment-type-one-balance {
      height: 70px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    /deep/.el-checkbox__label {
      font-size: 12px;
      color: #787878;
    }
    /deep/.el-checkbox {
      margin-left: 100px;
      width: 60%;
    }
    /deep/.el-checkbox__input {
      border-color: #dcdfe6;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
      background: #db4437;
      border-color: #db4437 !important;
    }
    /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #dcdfe6;
    }
    /deep/.el-checkbox__inner:hover {
      border-color: #dcdfe6;
    }
    .payment-type-text {
      width: 28%;
      text-align: right;
    }
  }
  .payment-type-other {
    width: 100%;
    background: #fff;
    .other-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    /deep/.el-radio__inner {
      width: 16px;
      height: 16px;
    }
    /deep/.el-radio__input.is-checked .el-radio__inner {
      outline: 0;
    }
    /deep/.el-radio__inner:hover {
      border-color: #dcdfe6 !important;
    }
    /deep/.el-radio__input + .el-radio__label {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #373d41;
    }
    .other-list {
      width: 100%;
      padding: 24px 0px;
    }
    .other-list-content {
      display: flex;
    }
    .other-list-item {
      width: 280px;
      height: 82px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-right: 24px;
      border-radius: 4px;
      border: 1px solid rgba(235, 235, 235, 1);
      img {
        width: 36px;
      }
    }
    .other-list-item-active {
      background: rgba(247, 252, 255, 1);
    }
  }
  .payment-submit {
    width: calc(100% - 180px);
    height: 100px;
    background: #fff;
    position: absolute;
    bottom: 0px;
    box-shadow: 0px -8px 8px 0px rgba(0, 0, 0, 0.05);
    right: 0px;
    div {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 100%;
    }
    p {
      color: #646464;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      span {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
    .el-button {
      width: 126px;
      height: 36px;
      background: #db4437;
      color: #fff;
      margin: 0 10px;
      border:none;
      margin-right: 39px;
    }
  }
}

  .payImgDialog {
      height: 406px;
      box-sizing: border-box;
      background-color: white;
      p {
        font-size: 16px;
        color: #646464;
        line-height: 30px;
        span {
          color: #D81212;
        }
      }
      p:nth-child(1) {
        margin-top: 20px;
      }
      .payImgCon {
        margin-top: 30px;
        text-align: center;
        height: 220px;
        display: flex;
        justify-content: center;
        align-items: center;
        img:first-child {
          width: 200px;
          height: 200px;
        }
        img:last-child {
          width: 170;
          height: 220px;
          margin-left: 23px;
        }
      }
      .succfulBox {
        margin-top: 30px;
        span {
          display: inline-block;
          width: 180px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border: 1px solid #D81212;
          font-size: 12px;
          color: #D81212;
        }
        span:hover {
          color: #fff;
          background-color: #D81212;
        }
      }
    }
    .mealBox {
    .balanceCon {
      height: 200px;
      .mealTop {
        height: 138px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      
        p:nth-child(2) {
          font-size: 14px;
          color: #919191;
          line-height: 14px;
          margin-top: 6px;
          margin-bottom: 10px;
        }
        p:nth-child(3) {
          font-size: 14px;
          color: #919191;
        }
      }
      .mealBottom {
        display: flex;
        justify-content: center;
        span {
          display: inline-block;
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #c8c8c8;
          font-size: 12px;
          color: #646464;
          cursor: pointer;
        }
        span:nth-child(2) {
          color: #fff;
          background: #D81212;
          border-color: #D81212;
          margin-left: 40px;
        }
      }
    }
  }
</style>